export const commonTags = {
  'code_resent': 'Code has been resent. If you still are not receiving your code, please contact support.',
  'LOGIN_CODE_EXPIRED': 'Code expired.',
}

export const mfaLoginStepTags = {
  'account_verified': 'Account verified',
  'default_pin_verify_error': 'An error has occured logging you in. Please try again.',
  'FAILED_TOO_MANY_ATTEMPTS': 'Your account was disabled upon too many failed logins, please contact support.',
  'LOGIN_CODE_NOT_FOUND': 'Wrong login code.',
  'too_many_mfa__attemps': 'Your account was disabled due to multiple unsuccessful code login attempts.',
};

export const noMFALoginTags = {
  'account_verified': 'Phone verified',
  'default_pin_verify_error': 'An error has occured verifying the code. Please try again.',
  'FAILED_TOO_MANY_ATTEMPTS': 'Too many failed attempts, please contact support.',
  'LOGIN_CODE_NOT_FOUND': 'Wrong code.',
};

export const emailTags = {
  'code_sent_check_your': 'Code sent...check your email',
  'code_sent_six_digit_check_your': 'Check your email and enter the six digit verification code sent to:',
  'code_sent_six_digit_check_your_forget_password': 'Check your email and enter the six digit verification code',
  'code_verified_with': 'You have successfully verified the following email:',
  'mfa_login_successfully_with': 'You have successfully verified your account with following email:',
  'send_code_failed': 'There was an issue trying to send your Personal Identification Number (CODE) to your email. Please contact customer support.',
  'too_many_attemps': 'Your email verification was disabled due to multiple unsuccessful code verification attempts.',
};

export const phoneTags = {
  'code_sent_check_your': 'Code sent...check your phone',
  'code_sent_six_digit_check_your': 'Check your phone and enter the six digit verification code sent to:',
  'code_sent_six_digit_check_your_forget_password': 'Check your phone and enter the six digit verification code',
  'code_verified_with': 'You have successfully verified the following number:',
  'reset_phone': 'Please reach out to customer service if you need to change the phone number.',
  'mfa_login_successfully_with': 'You have successfully verified your account with following number:',
  'send_code_failed': 'There was an issue trying to send your Personal Identification Number (CODE) to your phone number. Please contact customer support.',
  'too_many_attemps': 'Your phone number verification was disabled due to multiple unsuccessful code verification attempts.',
};
